module.exports = __webpack_public_path__ + "img/0Q3A7692_L_Foamcore_MockedUp.0d37c32f.jpg";